import { z } from '@exodus/zod';
import { memoize } from '@exodus/basic-utils';
const createRestoreTimeReport = ({ restoreTime }) => ({
    namespace: 'restoreTime',
    export: async ({ walletExists } = Object.create(null)) => {
        if (!walletExists)
            return null;
        return restoreTime.formatData();
    },
    getSchema: memoize(() => z.string().nullable()),
});
const restoreTimeReportDefinition = {
    id: 'restoreTimeReport',
    type: 'report',
    factory: createRestoreTimeReport,
    dependencies: ['restoreTime'],
    public: true,
};
export default restoreTimeReportDefinition;
